export const CSSUnits = ["px", "%", "em", "rem"];
export const CSSPositions = ["top", "right", "bottom", "left"];
